import React, { useEffect } from 'react';
import { TileSleekGridGroup } from '../../shared/components/tileSleekGridGroup';
import { malnutriScreenTileData } from '../../shared/shared.constants';
import { NavigationButtons } from '../../shared/components/navigationButtons';
import { TypographyH1 } from './style';
import { BoxStyled } from '../estimatingRequirements/esLandingScreen/style';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { setRouteArr, setRouteObj } from '../../store/slices/metaDataSlice';
import { useDispatch } from 'react-redux';
import { customPalette } from '../../styles/palette';

export const MalnutritionScreening = () => {
  const dispatch = useDispatch();
  const { patientInformation, optedOptions } = useAppSelector(metaDataSelector);
  const { metric } = patientInformation;
  const { usualWeight } = metric;
  const { routeArr, routeObj } = optedOptions;

  const filteredMalnutrionTileData = malnutriScreenTileData.map((item) => {
    if (item.tileText.toLowerCase().trim() === 'must') {
      if (!usualWeight) {
        return { ...item, disabled: true };
      }
      return item;
    }
    return item;
  });

  useEffect(() => {
    if (routeArr.length) {
      dispatch(
        setRouteArr(
          routeArr.filter((item) => item !== '/malnutrition-screening')
        )
      );
      dispatch(setRouteObj({ ...routeObj, malnutrition_screening: false }));
    }
  }, []);

  return (
    <>
      <TypographyH1
        sx={{
          fontFamily: 'BGRegular',
          fontWeight: 'bolder',
          color: customPalette.primaryDark,
          fontSize: '1.625rem',
          lineHeight: '1.875rem',
          textAlign: 'center',
          width: '70%',
          paddingTop: '1.5rem'
        }}
        className={'width-75'}
      >
        Malnutrition Assessment Tools
      </TypographyH1>
      <BoxStyled>
        <TileSleekGridGroup tileData={filteredMalnutrionTileData} />
      </BoxStyled>
      <NavigationButtons
        nextDisabled={false}
        nextRoute={''}
        nextVisible={false}
      />
    </>
  );
};
